// components
import { Typography } from '@centria-ui-atoms/typography'

// prime components
import { Checkbox as PrCheckbox } from 'primereact/checkbox'

// styles
import classes from './styles.module.scss'

// types
import type { CheckboxProps as PrCheckboxProps } from 'primereact/checkbox'
import type { FC } from 'react'

export interface CheckboxProps extends PrCheckboxProps {
  label?: string
}

export const Checkbox: FC<CheckboxProps> = ({
  label,
  className = '',
  ...props
}) => {
  return (
    <div className='d-flex gap-2 align-items-center'>
      <PrCheckbox {...props} className={`${className} ${classes.checkbox}`} />
      {label && (
        <Typography
          Tag='label'
          fontSize='small'
          htmlFor={props.inputId}
          className={classes.label}>
          {label}
        </Typography>
      )}
    </div>
  )
}
